export default __webpack_public_path__ + "static/media/advantageBgDec2.975bbbb1.png";